import { fork } from 'redux-saga/effects';
import comparisonSaga from './comparisonSaga';
import surveyResultSaga from './resultSaga';

export default function* engagementSurveySaga() {
  yield fork(surveyResultSaga);
  yield fork(comparisonSaga);
}
